import { z } from "zod";

/**
 * Common ID Parameter Schema
 */
export const IdParamSchema = z.object({ id: z.string().min(1) });
export type IdParamDTO = z.infer<typeof IdParamSchema>;

export const StudentPackageParamsSchema = z.object({
  id: z.string().min(1),
  packageId: z.string().min(1),
});
export type StudentPackageParamsDTO = z.infer<typeof StudentPackageParamsSchema>;
